module.exports = __webpack_public_path__ + "97d4785683a911f2bef08c3857f07c07.MP3";